// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAA9vG7JsfuS-AUu9wBa-XhmyTPns304wI",
  authDomain: "busagentweb-c84e2.firebaseapp.com",
  projectId: "busagentweb-c84e2",
  storageBucket: "busagentweb-c84e2.firebasestorage.app",
  messagingSenderId: "218231733109",
  appId: "1:218231733109:web:7b127f634f8c06b118313c",
  measurementId: "G-FBHXNXTDHW"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Initialize Auth with persistence BEFORE first access (prevents UID race conditions)
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
});

export const db = getFirestore(app);

/**
 * Ensures that the user is anonymously authenticated before writing to Firestore.
 * Waits for the initial auth state to be hydrated (prevents UID race conditions).
 * This is required for Firestore Rules that check request.auth != null
 * @returns {Promise} Promise that resolves with the authenticated anonymous user
 */
export function ensureAnonAuth() {
  return new Promise((resolve, reject) => {
    const unsub = onAuthStateChanged(
      auth,
      async (user) => {
        try {
          if (user) {
            unsub();
            return resolve(user);
          }
          const cred = await signInAnonymously(auth);
          unsub();
          resolve(cred.user);
        } catch (e) {
          unsub();
          reject(e);
        }
      },
      reject
    );
  });
}